import { render, staticRenderFns } from "./catalog-results.vue?vue&type=template&id=6979240a"
import script from "./catalog-results.vue?vue&type=script&lang=js"
export * from "./catalog-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports